module.exports = __webpack_public_path__ + "static/qrcode-e6e7cf25ad05b65d92ff6ae729ca43d1.webp";